import React from "react"
import MyCard from "@common-utils/MyCard"
import MyAlert from "@common-utils/MyAlert"

export function CompteParametres() {
     return (
          <MyCard>
               <MyCard.Header>Paramètres du compte</MyCard.Header>
               <MyCard.Body>
                    <MyAlert type={"primary"}>Coming soon ...</MyAlert>
               </MyCard.Body>
          </MyCard>
     )
}
